import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import IframeBridge from 'IframeBridge';
import { findImage } from 'utils/Utils';
import { usePaymentState } from 'payment_state/PaymentStateContext';

const ErrorPage = () => {
  const { t } = useTranslation();
  const { paymentState } = usePaymentState();
  const returnType = window.sessionStorage.getItem('returnType');

  useEffect(() => {
    if (returnType === 'DIRECT') {
      closeProcess();
    }
  }, [returnType]);

  const closeProcess = () => {
    if (sessionStorage.getItem('formSubmitted') === 'true') {
      sessionStorage.removeItem('formSubmitted');
    }

    const returnObject = {
      resultStatus: 'FAILED',
      resultCode: paymentState.resultCode,
      resultMessage: paymentState.resultMessage,
      tid: paymentState.tid,
      orderId: paymentState.orderId,
      mallReserved: paymentState.mallReserved,
      returnUrl: paymentState.returnUrl,
      schemeGroup: paymentState.schemeGroup,
      schemeCode: paymentState.schemeCode,
    };

    if (isMobile) {
      if (paymentState.returnUrl.includes('shopifyConfirm')) {
        window.location.href = paymentState.cancelUrl!;
        return;
      }

      const url = new URL(paymentState.returnUrl);
      const params = new URLSearchParams(url.search);
      params.set('resultStatus', 'FAILED');
      params.set(
        'resultCode',
        paymentState.resultCode ? paymentState.resultCode : '',
      );
      params.set(
        'resultMessage',
        paymentState.resultMessage ? paymentState.resultMessage : '',
      );
      params.set('tid', paymentState.tid);
      params.set('orderId', paymentState.orderId);
      params.set(
        'mallReserved',
        paymentState?.mallReserved ? paymentState.mallReserved : '',
      );
      params.set(
        'schemeGroup',
        paymentState?.schemeGroup ? paymentState.schemeGroup : '',
      );
      params.set(
        'schemeCode',
        paymentState?.schemeCode ? paymentState.schemeCode : '',
      );
      window.location.href = url + '?' + params;
    } else {
      window.sessionStorage.removeItem('auth');
      window.sessionStorage.removeItem('mid');
      window.sessionStorage.removeItem('clientKey');
      window.sessionStorage.removeItem('isError');
      IframeBridge.sendViewOff(returnObject);
    }
  };

  const handleAllClose = e => {
    e.preventDefault();
    closeProcess();
  };

  return (
    <>
      <div className="completed">
        <div className="middle">
          <div className="icon">
            <img src={findImage('error.png')} />
          </div>
          <div className="title">{t('payment_error')}</div>
          <div className="text" style={{ whiteSpace: 'pre-line' }}>
            {t('payment_error_msg')}
          </div>
          {paymentState.resultMessage !== null &&
            paymentState.resultMessage !== undefined &&
            paymentState.resultMessage.length > 0 && (
              <div className="text" style={{ whiteSpace: 'pre-line' }}>
                ({paymentState.resultMessage})
              </div>
            )}
        </div>
      </div>
      <div className="completed-btn">
        <div className="box confirmBox">
          <button className="all-close" onClick={handleAllClose}>
            {t('close')}
          </button>
        </div>
      </div>
    </>
  );
};

export default ErrorPage;
